import PageDTO from "@/api/commons/PageDTO";

export default class FiltroServicoSemPrestadorDTO {
  dataInicial?: string;
  dataFinal?: string;
  pagination: PageDTO;
  tipoServico?: string;
  cidade?: string;

  constructor(
    pagination: PageDTO,
    dataInicial?: string,
    dataFinal?: string,
    tipoServico?: string,
    cidade?: string
  ) {
    this.dataInicial = dataInicial;
    this.dataFinal = dataFinal;
    this.pagination = pagination;
    this.tipoServico = tipoServico;
    this.cidade = cidade;
  }
}
